/* eslint-disable no-loop-func */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import cssClasses from "./ForgetPassword.module.css";

import strip1 from "../../Assets/Images/strip1.svg";
import strip2 from "../../Assets/Images/strip2.svg";
import strip3 from "../../Assets/Images/strip3.svg";
import strip4 from "../../Assets/Images/strip4.svg";
import logo from "../../Assets/Images/vjLogo.jpg";

import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";
import axios from "axios";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
// import GreenChecked from "../Icons/GreenChecked";
import InfoIcon from "../Icons/InfoIcon";
import { checkIsEmailExist, checkIsEmailExistFP, sendResetPasswordMail } from "../../Services/LoginService";
import { errorTost, successTost } from "../../Services/Toast";

const useStyles = makeStyles((theme) => ({
    title: {
      color: "#1C1C1C",
      fontFamily: "Inter-Medium",
      fontSize: "2.4rem",
      lineHeight: "3.2rem",
      marginBottom: "1rem",
    },
    label: {
      display: "inline-block",
      fontFamily: "Inter-Medium",
      fontWeight: "400",
      fontSize: "1.4rem",
      lineheight: "2rem",
      /* identical to box height, or 143% */
  
      /* Gray/500 */
  
      color: "#667085",
      marginRight: "0.4rem",
    },
    signUp: {
      display: "inline-block",
      fontFamily: "Inter-Medium",
      fontWeight: "500",
      fontSize: "1.4rem",
      lineheight: "2rem",
      cursor: "pointer",
      color: "#175CD3",
    },
  }));


export default function ForgetPassword(){
  const navigate = useNavigate();
    const classes = useStyles();
  const [details,setDetails]=useState({
    userEnteredId:'',
  });
  const [helperText,setHelperText]=useState({
    userEnteredId:''
  })
    function getUserDetails(){
      if(details.userEnteredId!==''){
      let signInType = details.userEnteredId.substring(0, 5).toUpperCase() === 'FOSID' ? 'FOS' : 'CP';
          let id = signInType === 'CP' ? details.userEnteredId.substring(4, 10) : details.userEnteredId.substring(5, 11);
          checkIsEmailExistFP(signInType, id)
          .then((resp) => {
            console.log(resp);
              if (resp.length === 0) {
                errorTost("Invalid Id");
              }else{
                if(signInType==='CP'){
                  sendResetPasswordMail(resp[0]?.CpContactPerson[0]?.email)
                  .then((resetLinkResp) => {
                    console.log("resp: ", resetLinkResp);
                    successTost(
                      "Reset password link sent successfully to " +
                      resp[0]?.billingName+
                        "( " +
                        resp[0]?.CpContactPerson[0]?.email +
                        " )"
                    );
                    navigate('/Login');

                  })
                  .catch((err) => {
                    console.log("err: ", err);
                    errorTost(
                      "Could not send reset password link to " +
                      resp[0]?.billingName
                    );
                  });
                }else if(signInType==='FOS'){
                  sendResetPasswordMail(resp[0]?.email)
                  .then((resetLinkResp) => {
                    console.log("resp: ", resetLinkResp);
                    successTost(
                      "Reset password link sent successfully to " +
                      resp[0]?.name+
                        "( " +
                        resp[0]?.email +
                        " )"
                    );
                    navigate('/Login');
                  })
                  .catch((err) => {
                    console.log("err: ", err);
                    errorTost(
                      "Could not send reset password link to " +
                      resp[0]?.name
                    );
                  });
                }
              }
          }).catch((err)=>{
            console.log(err);
            errorTost(err.message);
          });
        }else{
          setHelperText((pre)=>{
            pre.userEnteredId="Please Enter Id";
            return {...pre}

          })
        }
    }
    return (
        <div className={cssClasses.wrapperPage}>
          <div className={cssClasses.backgroundImage}>
            <img
              src={strip2}
              className={cssClasses.strip2}
              alt="backgroundImage"
            ></img>
            <img
              src={strip3}
              className={cssClasses.strip3}
              alt="backgroundImage"
            ></img>
            <div className={cssClasses.registerationBlock}>
              <div>
                <img src={logo} style={{ width: "23rem" }} alt="vj-logo"></img>
              </div>
              <div className={classes.title}>Forgot Password</div>
              <div style={{ textAlign: "left", textTransform: "uppercase" }}>
                <CustomInput
                  value={details.userEnteredId}
                  label={"User CP/FOS Id"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    console.log(newValue);
                   
                    setDetails((pre) => {
                      pre.userEnteredId = newValue;
                      return { ...pre };
                    });
                    helperText.userEnteredId = "";
                   
                  }}
                  placeholder="Enter CP/FOS Id"
                  inputType="label"
                helperText={helperText.userEnteredId}
                
                />
              </div>
          
              <div>
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                  }}
                  btnName={"Send Reset Password Link"}
                 clicked={()=>{getUserDetails()}}
                //   isLoading={}
                  loaderColor={"#fff"}
                />
              </div>
    
              <div>
                <div className={classes.label}>Back to login?</div>
                <div className={classes.signUp} onClick={()=>{
                  navigate('/Login');
                }}>
                  Login
                </div>
              </div>
            
            </div>
            </div>
        </div>
      );
}